// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store' 
import {post} from './utils/http' 
import Print from './utils/print' 
import VueResource from 'vue-resource'
import Vuex from 'vuex' 
import axios from 'axios'
import qs from 'qs'
import VueLazyload from 'vue-lazyload'
import infiniteScroll from  'vue-infinite-scroll'
import ElementUI from 'element-ui';
import MessageModel from './components/MessageModel'
// import InputNumber from './components/InputNumber'
import '../theme/index.css'
import '../static/css/iconfont/iconfont.css' 
import VueParticles from 'vue-particles'  
Vue.use(VueParticles)  
// import Blob from './vendor/Blob'
// import Export2Excel from './vendor/Export2Excel'
Vue.config.productionTip = false
Vue.use(ElementUI); 
Vue.use(VueResource);
Vue.use(infiniteScroll);
Vue.use(Vuex); 
Vue.use(Print);
Vue.component('MessageModel',MessageModel);
// Vue.component('InputNumber',InputNumber);
Vue.use(MessageModel); 
// Vue.use(InputNumber); 
Vue.prototype.$post = post;  
Vue.prototype.axios = axios;  
Vue.use(VueLazyload, {
  loading: '../static/img/loading-svg/loading-img.svg',
  // loading: '../static/img/loading-svg/loading-bars.svg',
  try: 3 // default 1
})
Vue.http.interceptors.push((request, next) => {
  request.credentials = true;
  next();
});
Vue.http.interceptors.push((request, next) => {
    let timeout;
    // 這裡改用 _timeout
    if (request._timeout) {
        timeout = setTimeout(() => {
　　　　　　　　//自定义响应体 status:408,statustext:"请求超时"，并返回给下下边的next
            next(request.respondWith(request.body, {
                 status: 408,
                 statusText: '请求超时'
            }));
            
        }, request._timeout);
    }
    next((response) => {
　　　　console.log(request._timeout)//如果超时输出408
　　　　console.log(response.status)//如果超时输出408
　　　　return response;
    })
})
// Vue.http.options.timeout = 20000;
let startApp = function () {
    console.log("目前的环境："+process.env.NODE_ENV);
    if(process.env.NODE_ENV === 'production' ){
        Vue.http.get('/ktn/static/config.json').then((res) => {
        // 基础地址
        // Vue.prototype.BASE_URL = res.body.BASE_URL;
        // axios.defaults.baseURL = Vue.prototype.BASE_URL;
        axios.defaults.baseURL = res.body.BASE_URL;
        // console.log("111打印main中production环境的内部res.body.BASE_UR"+JSON.stringify(res))
        console.log("111打印main中production环境的内部res.body.BASE_URL"+res.body.BASE_URL);
        console.log("111打印main中production环境的内部URL"+axios.defaults.baseURL);
        new Vue({
          el: '#app',
          router, 
          store, 
          axios, 
          components: { App },
          template: '<App/>'
        })

      });
    }else{
    console.log("打印main中development环境的url"+axios.defaults.baseURL);
        /* eslint-disable no-new */
        new Vue({
          el: '#app',
          router, 
          store, 
          axios, 
          components: { App },
          template: '<App/>'
        })
    };
};
startApp();



// WEBPACK FOOTER //
// ./src/main.js